import AbstractElement from "./AbstractElement";
import SectionTab from "../components/tab/SectionTab";
import Product from "../components/product/Product";
import CarouselTab from "../components/tab/CarouselTab";


class SpecElement extends AbstractElement {
    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        this.initTabs();
    }
    private initTabs(): void {
        const tabSpec = new CarouselTab(this.template.find('#tabSpec'));
        tabSpec.initCarousel({
            items: 1,
            loop: false,
            margin: 20,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true
        });
    }
}

export default SpecElement;